import { IDatiqAction, IDatiqRulesData, IDatiqRulesRule } from '@dat/iq-proxy';

/**
 * Creates a rules data object that will always fire
 * @param action The IDatiqAction that you want to always fire
 * @returns IDatiqRulesData object with the action provided
 */
export const createActionNoRules = (
    action: IDatiqAction,
): IDatiqRulesData<IDatiqAction> => ({
    rules: [],
    data: action,
});

/**
 * Creates a list of actions that will always fire
 * @param actions Array of IDatiqAction objects that should always fire
 * @returns An array of IDatiqRulesData objects with the actions list provided
 */
export const createActionListNoRules = (
    actions: IDatiqAction[],
): IDatiqRulesData<IDatiqAction>[] => {
    return actions.map((action) => createActionNoRules(action));
};

/**
 * Creates a list of actions that all fire when the same rules pass
 * @param actions List of actions that should fire when rules pass
 * @param rules List of rules to evaluate
 * @returns Array of objects containing the array of rules and the action
 */
export const createActionListSameRules = (
    actions: IDatiqAction[],
    rules: IDatiqRulesRule[],
): {
    rules: IDatiqRulesRule[];
    data: IDatiqAction;
}[] => {
    return actions.map((action) => createActionRule(rules, action));
};

/**
 * Creates a single action that will fire when provided rules pass
 * @param rules The list of rules to evaluate
 * @param action The action to be fired when rules pass
 * @returns Object containing the array of rules and the action
 */
export const createActionRule = (
    rules: IDatiqRulesRule[],
    action: IDatiqAction,
): { rules: IDatiqRulesRule[]; data: IDatiqAction } => {
    return {
        rules,
        data: action,
    };
};
